import { createContext } from 'react';

// Kept apart from the provider so cookie-consent.tsx exports only a component, which is what
// keeps React Fast Refresh working for it (eslint react-refresh/only-export-components).
export interface CookieConsentContextState {
    acceptedEssential: boolean;
    acceptedNonEssential: boolean;
    acceptAll: () => void;
    acceptEssentialOnly: () => void;
}

export const CookieConsentContext = createContext<CookieConsentContextState>({
    acceptedEssential: false,
    acceptedNonEssential: false,
    acceptAll: () => {
        throw new Error('acceptAll method not implemented');
    },
    acceptEssentialOnly: () => {
        throw new Error('acceptEssentialOnly method not implemented');
    },
});
